import React from 'react';

import prettyBytes from 'pretty-bytes';
import { useDropzone } from 'react-dropzone';

import Button from '@atlaskit/button';
import { HelperMessage } from '@atlaskit/form';

import { maxFileSize } from '@qality/common-config';

import {
  ActionText,
  Center,
  Dropzone,
  Files,
} from './DropzoneWithFiles.styled';
import File from './File';
import FileUploadIcon from './FileUploadIcon';

// eslint-disable-next-line complexity
export default function DropzoneWithFiles({ file, onRemoveFile, onDrop }: any) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple: false,
    disabled: file,
    accept: '.csv, application/vnd.ms-excel, text/csv',
    onDrop,
  });

  return (
    <>
      <Dropzone {...getRootProps({ active: !file })}>
        {file ? (
          <Files>
            <File file={file} onRemoveFile={onRemoveFile} />
          </Files>
        ) : (
          <>
            <FileUploadIcon />
            <Center>
              <input {...getInputProps()} />
              {!isDragActive ? (
                <div>
                  <ActionText>Drag and drop file here or</ActionText>
                  <Button>Browse files</Button>
                </div>
              ) : (
                <ActionText>Drop the file here ...</ActionText>
              )}
            </Center>
          </>
        )}
      </Dropzone>
      <HelperMessage>
        Max size of file: {prettyBytes(maxFileSize)}
      </HelperMessage>
    </>
  );
}
